(function ($) {
    $(window).on('load', function () {
        var params = getURLParameters($);
        var params_count = Object.keys(params).length;
        if (params_count > 0) {
            for (var key in params) {
                var value = params[key];
                if (key == "Year") {
                    $('.filters-block .filter-wrapper .filter-content .wrapper .filter-dropdown #year').val(value);
                } else if (key == "Month") {
                    $('.filters-block .filter-wrapper .filter-content .wrapper .filter-dropdown #month').parent().css('display', 'block');
                    $('.filters-block .filter-wrapper .filter-content .wrapper .filter-dropdown #month').val(value);
                }
            }
            setTimeout(function () {
                $(".filters-block .filter-wrapper .filter-content .wrapper .filter-dropdown select").selectBoxIt('refresh');
            }, 50);
        }
    });

    var val1 = 0;
    var val = 0;

    $(document).on('change', '.filters-block .filter-wrapper .filter-content .wrapper .filter-dropdown #month', function () {
        // $('.news-grid, .news-landing-year-filter').hide();
        // $('.landing-loader').show();
        var params = getURLParameters();
        delete params.page;
        val = $(this).val();
        if (val === '') {
            delete params.Month;
        } else {
            params.Month = val;
        }
        setURLParameters(params);
        location.reload(true);
        return false;
    });
    $(document).on('change', '.filters-block .filter-wrapper .filter-content .wrapper .filter-dropdown #year', function () {
        // $('.news-grid, .news-landing-year-filter').hide();
        // $('.landing-loader').show();
        var params = getURLParameters();
        delete params.page;
        val1 = $(this).val();
        if (val1 === '') {
            delete params.Month;
            delete params.Year;
            $('.filters-block .filter-wrapper .filter-content .wrapper .filter-dropdown #month').parent().css('display', 'none');
        } else {
            params.Year = val1;
            $('.filters-block .filter-wrapper .filter-content .wrapper .filter-dropdown #month').parent().css('display', 'block');
        }
        setURLParameters(params);
        location.reload(true);
        return false;
    });

    $('.filters-block.events .events-filter .events-result .grid-view').on('click', function () {
        $(this).siblings().removeClass('selected');
        $(this).addClass('selected');
        $('.filters-block .card-wrap').addClass('view-grid');
        if ($('.filters-block').hasClass('hoover-press')) {

            var thisSec = $('.filters-block ');
            setLines(thisSec);

        }
    });
    $('.filters-block.events .events-filter .events-result .list-view').on('click', function () {
        $(this).siblings().removeClass('selected');
        $(this).addClass('selected');
        $('.filters-block .card-wrap').removeClass('view-grid');
        if ($('.filters-block').hasClass('hoover-press')) {
            var thisSec = $('.filters-block ');
            setLines(thisSec);
        }
    });

})(jQuery);